import { ENDPOINT } from '../../api/config/endpoints';

// Local static file — use fetch to avoid axiosInstance baseURL
export const getProducts = async ({ signal } = {}) => {
  const response = await fetch(ENDPOINT.DUMMY.PRODUCTS, { signal });
  if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
  return response.json();
};
